import { patchTaskChecklist } from '@/apis/common'

export function onDragStart() {
    if (!this.isDragging) {
        if (this.closeAllChecklistEditBoxes) {
            this.closeAllChecklistEditBoxes()
        }
        this.isDragging = true
    }
}
export function onDragEnd() {
    this.isDragging = false
}
export function onChecklistItemDrop(checklist, dragResult) {
    const { removedIndex, addedIndex, payload } = dragResult;
    const result = checklist.options
    let itemToAdd = payload;
    itemToAdd = result.splice(removedIndex, 1)[0];
    result.splice(addedIndex, 0, itemToAdd);

    checklist.options = result;
    updateChecklistItemPositions(checklist);
}
export function updateChecklistItemPositions(checklist) {
    checklist.options.forEach((option, index) => {
        option.position = index + 1
    })
}
export function updateChecklistItemPositionsAsync(checklist, isCategoryChecklist = false) {
    checklist.options.forEach((option, index) => {
        option.position = index + 1
    })
    
    let options = checklist.options.map(option => {
        return {
            id: option.id,
            position: option.position
        }
    })
    if (isCategoryChecklist) {
        console.log(3)
    } else {
        return patchTaskChecklist(this.taskId, checklist.id, {
            options
        })
    }
}